import { useContext } from 'react';
import { GroupsContext } from '.';

export default function useGroupsContext() {
  return useContext(GroupsContext);
}
